(() => {
  const HEADER_SELECTOR = "[data-el-header]";
  const CART_EVENTS = [
    "cart:updated",
    "cart:refresh",
    "cartQuantityUpdated",
    "product:added",
    "ajaxProduct:added",
  ];

  function initAllHeaders() {
    document.querySelectorAll(HEADER_SELECTOR).forEach(initHeader);
  }

  function initHeader(sectionRoot) {
    if (!sectionRoot || sectionRoot.dataset.initialized === "true") return;
    sectionRoot.dataset.initialized = "true";

    const body = document.body;
    const rootUrl = sectionRoot.dataset.rootUrl || "/";

    const overlay = sectionRoot.querySelector("[data-el-overlay]");
    const menuDrawer = sectionRoot.querySelector("[data-el-menu-drawer]");
    const menuToggle = sectionRoot.querySelector("[data-el-menu-toggle]");
    const closeButtons = sectionRoot.querySelectorAll("[data-el-close]");
    const cartCount = sectionRoot.querySelector("[data-el-cart-count]");

    const fixedHeader = sectionRoot.querySelector(".el-fixed-header");
    let scrollTicking = false;

    function updateHeaderAppearance() {
      if (!fixedHeader) return;

      const isAtTop = window.scrollY <= 0;
      fixedHeader.classList.toggle("is-scrolled", !isAtTop);
    }

    function onScroll() {
      if (scrollTicking) return;

      scrollTicking = true;
      window.requestAnimationFrame(() => {
        updateHeaderAppearance();
        scrollTicking = false;
      });
    }

    let activeDrawer = null;

    function openMenu() {
      if (!menuDrawer || !overlay) return;

      closeMenu(false);

      menuDrawer.classList.add("is-open");
      menuDrawer.setAttribute("aria-hidden", "false");

      overlay.classList.add("is-open");
      body.classList.add("el-fixed-drawer-open");

      if (menuToggle) {
        menuToggle.setAttribute("aria-expanded", "true");
      }

      activeDrawer = menuDrawer;
    }

    function closeMenu(resetFocus = true) {
      if (menuDrawer) {
        menuDrawer.classList.remove("is-open");
        menuDrawer.setAttribute("aria-hidden", "true");
      }

      if (overlay) {
        overlay.classList.remove("is-open");
      }

      body.classList.remove("el-fixed-drawer-open");

      if (menuToggle) {
        menuToggle.setAttribute("aria-expanded", "false");
      }

      if (resetFocus && activeDrawer === menuDrawer && menuToggle) {
        menuToggle.focus();
      }

      activeDrawer = null;
    }

    async function getCart() {
      const response = await fetch(`${rootUrl}cart.js`, {
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch cart");
      }

      return response.json();
    }

    function updateCartCount(cart) {
      if (!cartCount) return;
      cartCount.textContent = String(cart?.item_count || 0);
    }

    function refreshCartCount() {
      if (!cartCount) return;

      getCart()
        .then(updateCartCount)
        .catch(() => {});
    }

    if (menuToggle) {
      menuToggle.addEventListener("click", () => {
        const isOpen = menuDrawer?.classList.contains("is-open");
        if (isOpen) {
          closeMenu();
        } else {
          openMenu();
        }
      });
    }

    closeButtons.forEach((button) => {
      button.addEventListener("click", () => closeMenu());
    });

    if (overlay) {
      overlay.addEventListener("click", () => closeMenu());
    }

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && activeDrawer === menuDrawer) {
        closeMenu();
      }
    });

    CART_EVENTS.forEach((eventName) => {
      document.addEventListener(eventName, refreshCartCount);
    });

    window.addEventListener("pageshow", refreshCartCount);

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", updateHeaderAppearance);
    window.addEventListener("pageshow", updateHeaderAppearance);

    updateHeaderAppearance();

    refreshCartCount();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAllHeaders);
  } else {
    initAllHeaders();
  }

  document.addEventListener("shopify:section:load", initAllHeaders);
})();
